import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SC from "./style.js";

const AccordianConatiner = (props) => {
  const {
    title = "",
    children,
    defaultExpanded = false,
    expand = true,
    width,
    boxShadow,
    border,
    marginRight,
  } = props;
  return (
    <>
      {SC.Globalstyles}
      <SC.MainComponent
        width={width}
        boxShadow={boxShadow}
        border={border}
        marginRight={marginRight}
      >
        <Accordion defaultExpanded={defaultExpanded}>
          {expand && (
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <SC.Heading>{title}</SC.Heading>
            </AccordionSummary>
          )}

          <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
      </SC.MainComponent>
    </>
  );
};

export default AccordianConatiner;
